var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emap-flow-modal-distributeSubmit" },
    [
      _c(
        "Modal",
        {
          attrs: { title: _vm.options.name, "mask-closable": false },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c(
                "Form",
                {
                  ref: "distributeForm",
                  attrs: {
                    model: _vm.distributeForm,
                    rules: _vm.ruleValidate,
                    "label-width": 100,
                  },
                },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: _vm.$LocalH5("recipient"),
                        prop: "assignee",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "ivu-input-wrapper" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "ivu-input-copy",
                              on: {
                                click: function ($event) {
                                  _vm.personPick = true
                                },
                              },
                            },
                            _vm._l(_vm.assignees, function (item, index) {
                              return _c(
                                "Tag",
                                {
                                  key: index,
                                  attrs: {
                                    type: "border",
                                    color: "blue",
                                    name: item.id,
                                    closable: "",
                                  },
                                  on: {
                                    "on-close": function ($event) {
                                      return _vm.delItem(item, index)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Select",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: false,
                                  expression: "false",
                                },
                              ],
                              attrs: { multiple: "", disabled: "" },
                              model: {
                                value: _vm.distributeForm.assignee,
                                callback: function ($$v) {
                                  _vm.$set(_vm.distributeForm, "assignee", $$v)
                                },
                                expression: "distributeForm.assignee",
                              },
                            },
                            _vm._l(_vm.assignees, function (item, index) {
                              return _c(
                                "Option",
                                { key: index, attrs: { value: item.id } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: _vm.$LocalH5("distributeInstru"),
                        prop: "desc",
                      },
                    },
                    [
                      _c("Input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          placeholder: _vm.$LocalH5("validDistriInstr"),
                        },
                        model: {
                          value: _vm.distributeForm.desc,
                          callback: function ($$v) {
                            _vm.$set(_vm.distributeForm, "desc", $$v)
                          },
                          expression: "distributeForm.desc",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: _vm.$LocalH5("pageView.msgType"),
                        prop: "way",
                      },
                    },
                    [
                      _c(
                        "CheckboxGroup",
                        {
                          model: {
                            value: _vm.distributeForm.way,
                            callback: function ($$v) {
                              _vm.$set(_vm.distributeForm, "way", $$v)
                            },
                            expression: "distributeForm.way",
                          },
                        },
                        _vm._l(_vm.ways, function (item) {
                          return _c(
                            "Checkbox",
                            { key: item.code, attrs: { label: item.code } },
                            [_c("span", [_vm._v(_vm._s(item.name))])]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { size: "large" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$LocalH5("buttonCancel")))]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { type: "primary", size: "large" },
                  on: {
                    click: function ($event) {
                      return _vm.onConfirm("distributeForm")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$LocalH5("buttonConfirm")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("emap-flow-pick", {
        attrs: { options: _vm.distributeForm.assignee, multiple: "" },
        on: { "on-confirm": _vm.onPickConfirm },
        model: {
          value: _vm.personPick,
          callback: function ($$v) {
            _vm.personPick = $$v
          },
          expression: "personPick",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }